import { Box, Center, Text } from "@chakra-ui/react";
import { ActionButton } from "../ActionButton";
import { Reveal } from "../Reveal";
import "../css/main.css";

export function MainInfo({ componentRef }) {
  return (
    <>
      <Center ref={componentRef} id={"mainInfo"}>
        <Box px={[5, 3, 20, 0]} maxW={850} className={"text"}>
          <Reveal direction="up" amount={0.15}>
            <Text fontSize={"22px"} fontWeight={"semibold"}>
              Kennst Du die folgenden Probleme?
            </Text>
          </Reveal>
          <br />
          <Reveal direction="up" delay={0.05}>
            <Text fontSize={"18px"}>
              - Trotz erheblicher Investitionen bringt deine
              <b> Webseite nicht die gewünschten Ergebnisse?</b>
              <br /> - Deine bestehende Webseite wird{" "}
              <b>von potenziellen Besuchern nicht gefunden?</b>
              <br /> - Obwohl Du zahlreiche Besucher verzeichnest,
              <b> bleiben die Konversionen aus?</b>
              <br />- Du glaubst, dass <b>professionelles Webdesign</b> immer
              teuer sein muss und maßgeschneiderte Lösungen nur großen
              Unternehmen vorbehalten sind?
            </Text>
          </Reveal>
          <br />
          <Reveal direction="up" delay={0.1}>
            <Text fontSize={"18px"}>
              Wir von WebWerk am Meer, <b>Deiner Webdesign Agentur in Kiel,</b>{" "}
              wissen, wie wichtig ein überzeugender Internetauftritt für Dein
              Unternehmen ist. Unser Team aus erfahrenen Webdesignern steht Dir
              zur Seite, um Deine Vision Wirklichkeit werden zu lassen. Wir
              bieten Dir maßgeschneiderte Lösungen, damit Du im digitalen Raum
              erfolgreich bist.
            </Text>
          </Reveal>
          <br />
          <Reveal direction="up" delay={0.15}>
            <Text fontSize={"18px"}>
              Egal, ob du eine neue Webseite erstellen, deine bestehende
              Webseite überarbeiten oder deine Sichtbarkeit in Suchmaschinen
              verbessern möchtest - bei WebWerk am Meer bist du an der richtigen
              Adresse für <b> professionelles Webdesign in Kiel</b>.
            </Text>
          </Reveal>
          <br />
          <Reveal direction="up" delay={0.2}>
            <Text fontSize={"18px"}>
              Du möchtest eine einzigartige Webseite, die Kunden anzieht?
              Vereinbare ein unverbindliches Erstgespräch und lass uns deine
              Vision verwirklichen.
            </Text>
          </Reveal>
          <br />
          <br />
          <Center>
            {" "}
            <Reveal direction="up" delay={0.25}>
              <ActionButton />
            </Reveal>
          </Center>
        </Box>
      </Center>
    </>
  );
}
